var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import tippy from "tippy.js";
export default class ShareButton {
    constructor() {
        this.tippyInstances = [];
        this.shareButtons = document.querySelectorAll('[data-share-button]');
        this.shareUrl = window.location.href;
        this.init();
    }
    init() {
        this.shareButtons.forEach((button) => {
            this.shareUrl = button.getAttribute('href') || window.location.href;
            this.initTooltip(button);
        });
    }
    initTooltip(button) {
        button.addEventListener("click", (event) => event.preventDefault());
        const contentElement = button.parentElement.querySelector('[data-share-options-tooltip]');
        if (!contentElement)
            return;
        const tippyInstance = tippy(button, {
            content: contentElement.innerHTML,
            arrow: false,
            animation: null,
            allowHTML: true,
            interactive: true,
            trigger: 'click',
            placement: 'bottom-start',
            onMount: () => {
                this.bindTooltipEvents();
            }
        });
        this.tippyInstances.push(tippyInstance);
    }
    bindTooltipEvents() {
        const copyButton = document.querySelector('.tippy-box [data-share-copy]');
        const emailButton = document.querySelector('.tippy-box [data-share-email]');
        if (copyButton) {
            copyButton.addEventListener('click', (event) => this.copyToClipboard(event));
        }
        if (emailButton) {
            emailButton.addEventListener('click', (event) => this.shareByEmail(event));
        }
    }
    copyToClipboard(event) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield navigator.clipboard.writeText(this.shareUrl);
                this.hideTooltips();
            }
            catch (error) {
                this.fallbackCopyToClipboard();
            }
        });
    }
    fallbackCopyToClipboard() {
        const textArea = document.createElement('textarea');
        textArea.value = this.shareUrl;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.hideTooltips();
    }
    shareByEmail(event) {
        const subject = encodeURIComponent(document.title);
        const message = event.target.closest('[data-sharer]').dataset.emailMessage || 'Check this out:';
        const body = encodeURIComponent(message + ' ' + this.shareUrl);
        const mailtoUrl = `mailto:?subject=${subject}&body=${body}`;
        window.location.href = mailtoUrl;
        this.hideTooltips();
    }
    hideTooltips() {
        this.tippyInstances.forEach(instance => instance.hide());
    }
}
